import Taskbar from '../components/Taskbar';
import AnimatedSection from '../components/AnimatedSection';
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";


const VoiceOfGlory = () => {
  const images = [
    "/images/Voiceofglory/Voiceofglory1.png",
    "/images/Voiceofglory/Voiceofglory2.jpg",
    "/images/Voiceofglory/Voiceofglory3.png"
  ];

  const captions = ["Voice Of Glory", "Voice Of Glory", "Voice Of Glory"];

  return (
    <>
      <Taskbar />
      <TwoColumnLayout sidebar={<AppSidebar />}>
      <div className="max-[942px]:pt-8 min-[942px]:mt-[51px] bg-bg text-text">
        
          <AnimatedSection images={images} captions={captions} title="Voice Of Glory" />
          <h2 className='text-3xl font-bold text-center mt-40 mb-10'>Coming Soon...</h2>
      </div>
      </TwoColumnLayout>
    </>
  );
};

export default VoiceOfGlory;
